import { takeEvery, put, call, fork, all, select } from 'redux-saga/effects'

import { indicateProgress } from '../api'
import { languageSelector } from '../i18n/selectors'

import * as constants from './constants'
import * as actions from './actions'
import { fetchLocationById, fetchLocations, fetchLocationByGrsId } from './api'
import { countriesFromHost } from 'shared/country'

export function* fetchLocationSaga({ id, requestId }) {
    const language = yield select(languageSelector)

    try {
        yield put(actions.receivedLocations(yield call(fetchLocationById, id, language), requestId))
    } catch (e) {
        // Swallow error to prevent blocking UI
    }
}

export function* fetchLocationByGrsIdSaga({ grsId, requestId }) {
    const language = yield select(languageSelector)

    try {
        yield put(actions.receivedLocations(yield call(fetchLocationByGrsId, grsId, language), requestId))
    } catch (e) {
        // Swallow error to prevent blocking UI
    }
}

export function* watchFetchLocationSaga() {
    yield takeEvery(constants.FETCH_LOCATION, fetchLocationSaga)
}

export function* watchFetchLocationByGrsSaga() {
    yield takeEvery(constants.FETCH_LOCATION_BY_GRS, fetchLocationByGrsIdSaga)
}

export function* fetchLocationsSaga(action) {
    const language = yield select(languageSelector)
    const { params: providedParams, page, requestId } = action
    const params = {
        'location.language': language,
        'location.address.countries': countriesFromHost(),
        ...providedParams,
    }

    try {
        const firstResponse = yield call(indicateProgress, ['locations'], fetchLocations, params, page)
        const {
            result: { first, totalPages },
        } = firstResponse

        let responses = firstResponse

        if (totalPages > 1 && first && page === undefined) {
            const pages = [...Array(totalPages).keys()].slice(1)
            const calls = pages.map(page => call(indicateProgress, ['locations'], fetchLocations, params, page))
            const remainingResponses = yield all(calls)

            responses = remainingResponses.reduce(
                (allResponses, response) => {
                    allResponses.entities.grsLocations = {
                        ...allResponses.entities.grsLocations,
                        ...response.entities.grsLocations,
                    }

                    allResponses.entities.locations = {
                        ...allResponses.entities.locations,
                        ...response.entities.locations,
                    }

                    allResponses.result.content.push(...response.result.content)

                    return allResponses
                },
                {
                    entities: {
                        locations: { ...firstResponse.entities.locations },
                        grsLocations: { ...firstResponse.entities.grsLocations },
                    },
                    result: {
                        content: [...firstResponse.result.content],
                    },
                }
            )
        }

        yield put(actions.receivedLocations(responses, requestId))
    } catch (exception) {
        yield put(actions.failedToFetchLocations())
    }
}

export function* watchFetchLocationsSaga() {
    yield takeEvery(constants.FETCH_LOCATIONS, fetchLocationsSaga)
}

export default function* rootSaga() {
    yield fork(watchFetchLocationSaga)
    yield fork(watchFetchLocationByGrsSaga)
    yield fork(watchFetchLocationsSaga)
}
